import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

import { CarPagination } from 'src/app/models/car';
import { CurrentQuery } from '../../../models/current-query';
import { Strings } from 'src/app/const/strings';
import { Lang } from 'src/app/models/lang';

@Component({
  selector: 'app-car-pagination',
  templateUrl: './car-pagination.component.html',
  styleUrls: ['./car-pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CarPaginationComponent implements OnInit {

  @Input() carPagination: CarPagination;
  @Input() currentRouterLinkPath: string;
  @Input() currentQueries: CurrentQuery[] = [];
  @Input() lang: Lang;

  strings = Strings;

  constructor() { }

  ngOnInit(): void {
  }

  getPagerQueryParams(page: number) {
    const queries = [...this.currentQueries]; // 配列のコピー
    queries.push({ key: 'page', value: page.toString() });
    const queryParams = {};
    queries.forEach(query => {
      queryParams[query.key] = query.value;
    });
    return queryParams;
  }

  get allDummyItems() {
    return Array(this.carPagination.totalCount);
  }

  isPageNumber(label: number | string): boolean {
    return typeof label === 'number';
  }

}
